<template>
  <div>
    <div class="card shadow">
      <div class="card-header bg-transparent">
        <div>
          <h3 class="mb-0">
            {{ $t('message.edit') }} {{ $tc('message.activite.titre', 1) }}
          </h3>
        </div>
      </div>

      <div class="card-body">
        <b-form >
          <b-container>
            <b-row>
              <b-col sm="12">
                <div  v-if="selectedMissions" class="mb-5">
                  <p  class="heading text-center mt-5">{{$t('message.detail.mission')}}</p>
                  <b-row class="my-2">
                    <b-col sm="12">
                      <b-table
                          striped
                          responsive
                          hover
                          bordered
                          :items="selectedMissions"
                          :fields="selectedMissionsField"
                      >
                        <template v-slot:cell(description)="data">
                          <p class="mb-0">{{ getDescription(data.value) }}</p>
                        </template>
                        <template v-slot:cell(statut)="data">
                          <p class="mb-0">{{ data.value == true || data.value == 1  ? $t('message.yes') : $t('message.no') }}</p>
                        </template>
                        <template v-slot:cell(dossier_medical_id)="data">
                          <p class="mb-0">{{ getNomPatient(data.value) }}</p>
                        </template>
                        <template v-slot:cell(action)="data">
                          <b-button @click="modifierMission(data)"  class="btn-sm btn-outline-primary" >
                            {{ $t('message.edit') }}
                          </b-button>
                          <b-button @click="deleteMission(data)"  class="btn-sm btn-outline-danger" >
                            {{ $t('message.delete') }}
                          </b-button>
                        </template>

                      </b-table>
                    </b-col>

                  </b-row>

                </div>

                <div v-if="$v.form.groupe_id.$model == '1' || $v.form.groupe_id.$model == '2'">
                  <b-form-group
                      id="patients-group"
                      :label="$t('message.nomPatient')"
                      label-for="patients"
                  >
                    <slim-element return-value="id" selected-id="patients" :afficher="$v.form.groupe_id.$model === 1 || $v.form.groupe_id.$model ===2" :element.sync="form.dossier_medical_id" :data.sync="mPatients"></slim-element>
                    <div class="invalid-feedback" v-if="$v.form.dossier_medical_id.$error">
                      {{ $t('message.requiredField') }}
                    </div>
                    <span v-if="errorshasField('dossier_medical_id')" class="custom-invalid">
                                                    {{getErrorsField('dossier_medical_id')}}
                                                    </span>
                  </b-form-group>
                </div>

                <b-form-group  v-if="$v.form.groupe_id.$model === 4"
                               id="nomActivite-group"
                               :label="$t('message.activite.nom')"
                               label-for="nomActivite"
                               description=""
                >
                  <b-form-input
                      id="nomActivite"
                      v-model="$v.form.nom_activite.$model"
                      :state="$v.form.nom_activite.$dirty ? !(errorshasField('nom_activite') || $v.form.nom_activite.$error) : null"
                      type="text"
                      required
                      placeholder=""
                      @focus="clearErrorField('nom_activite')"
                  ></b-form-input>

                  <b-form-invalid-feedback v-if="!$v.form.nom_activite.required">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback v-else-if="errorshasField('nom_activite')">
                    {{ getErrorsField('nom_activite') }}
                  </b-form-invalid-feedback>

                </b-form-group>

                <b-form-group  v-if="$v.form.groupe_id.$model ===3"
                               id="nomPartenaire-group"
                               :label="$t('message.nomPartenaire')"
                               label-for="nom"
                               description=""
                >
                  <b-form-input
                      id="nomPartenaire"
                      v-model="$v.form.nom_partenaire.$model"
                      :state="$v.form.nom_partenaire.$dirty ? !(errorshasField('nom_partenaire') || $v.form.nom_partenaire.$error) : null"
                      type="text"
                      required
                      placeholder=""
                      @focus="clearErrorField('nom_partenaire')"
                  ></b-form-input>

                  <b-form-invalid-feedback v-if="!$v.form.nom_partenaire.required">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback v-else-if="errorshasField('nom_partenaire')">
                    {{ getErrorsField('nom_partenaire') }}
                  </b-form-invalid-feedback>

                </b-form-group>

                <b-form-group
                    id="description-group"
                    :label="$t('message.description')"
                    label-for="description"
                >

                  <slim-element
                      return-value="id"
                      selected-id="descriptions"
                      :afficher="showDescription"
                      :element.sync="$v.editable.description.$model"
                      :data.sync="missions">
                  </slim-element>
                </b-form-group>

                <b-form-group
                    id="commentaire-group"
                    :label="$tc('message.commentaires',1)"
                    label-for="commentaire"
                >
                  <div v-if='$v.editable.description.$model === "1"'>
                    <slim-element
                        return-value="text"
                        selected-id="commentaire"
                        :afficher='$v.editable.description.$model === "1"'
                        :element.sync="editable.commentaire"
                        :data.sync="commentaireOptions">
                    </slim-element>
                  </div>
                  <b-form-input
                      v-if="$v.editable.description.$model !== '1'"
                      id="commentaire"
                      v-model="$v.editable.commentaire.$model"
                      :state="$v.editable.commentaire.$dirty ? !(errorshasField('commentaire') || $v.editable.commentaire.$error) : null"
                      required
                      @focus="clearErrorField('commentaire')"
                  ></b-form-input>
                  <b-form-invalid-feedback v-if="errorshasField('commentaire')">
                    {{ getErrorsField('commentaire') }}
                  </b-form-invalid-feedback>
                </b-form-group>

                <div>
                  <label class="form__label" for="hasDesc">{{ $t('message.missionCloture') }}</label>
                  <div class="toggle">
                    <input id="hasDesc" type="checkbox" v-model="editable.statut"/>
                    <label for="hasDesc">
                      <div class="toggle__switch"></div>
                    </label>
                  </div>
                </div>

                <b-form-group
                    id="dateCloture-group"
                    :label="$t('message.dateCloture')"
                    label-for="dateCloture"
                    description="">
                  <b-form-input
                      id="dateCloture"
                      v-model="$v.editable.date_cloture.$model"
                      :state="$v.editable.date_cloture.$dirty ? !(errorshasField('date_cloture') || $v.editable.date_cloture.$error) : null"
                      type="date"
                      required
                      @focus="clearErrorField('date_cloture')"
                  ></b-form-input>

                  <b-form-invalid-feedback v-if="!$v.editable.date_cloture.required">
                    {{ $t('message.requiredField') }}
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback v-else-if="errorshasField('date_cloture')">
                    {{ getErrorsField('date_cloture') }}
                  </b-form-invalid-feedback>
                </b-form-group>

              </b-col>
            </b-row>
            <b-row class="justify-content-sm-center">
              <b-button @click="addMission" variant="dark" v-if="can && showDescription">
                {{ $t('message.add') }}
              </b-button>

              <b-button @click="editMission" variant="dark" v-if="can && !showDescription">
                {{ $t('message.edit') }}
              </b-button>
            </b-row>
            <p  class="heading text-center mt-5">{{$t('message.detail.activite')}}</p>
            <b-row>
              <b-col sm="12">
                <b-form-group
                    id="groupeActivite-group"
                    :label="$t('message.groupeActivite')"
                    label-for="institution"
                >
                  <b-form-input :value="groupeActivite" :disabled="true">
                  </b-form-input>
                </b-form-group>
                <b-col sm="12" class="mt-2">
                  <div>
                    <label class="form__label" for="hasDesc">{{ $t('message.activiteCloture') }}</label>
                    <div class="toggle">
                      <input id="hasDesc2" type="checkbox" v-model="form.statut_activite"/>
                      <label for="hasDesc2">
                        <div class="toggle__switch"></div>
                      </label>
                    </div>
                  </div>

                  <b-form-group
                      id="dateCloture2-group"
                      :label="$t('message.dateCloture')"
                      label-for="dateCloture2"
                      description="">
                    <b-form-input
                        id="dateCloture"
                        v-model="$v.form.date_cloture_activite.$model"
                        :state="$v.form.date_cloture_activite.$dirty ? !(errorshasField('date_cloture') || $v.form.date_cloture_activite.$error) : null"
                        type="date"
                        required
                        @focus="clearErrorField('date_cloture')"
                    ></b-form-input>

                    <b-form-invalid-feedback v-if="!$v.form.date_cloture_activite.required">
                      {{ $t('message.requiredField') }}
                    </b-form-invalid-feedback>

                    <b-form-invalid-feedback v-else-if="errorshasField('date_cloture')">
                      {{ getErrorsField('date_cloture') }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-col>
            </b-row>
            <b-row class="justify-content-sm-center">
              <b-button @click="onSubmit" variant="primary" v-if="can">
                {{ $t('message.edit') }}
              </b-button>
            </b-row>
          </b-container>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import _ from "lodash";
import SlimElement from "@/views/Layout/SlimElement";

export default {
  name: "Edit",
  components: {
    SlimElement,
  },
  computed: {
    ...mapGetters(["activite", 'hasAdminRole','patients','groupeActivites',
      'hasGestionnaireRole', 'hasPraticienRole', 'hasMedecinControleRole','hasAssistante']),

    form:function (){
      let fArray = _.pick(this.activite,['groupe_id','statut','date_cloture','id','slug']);
      fArray.statut_activite = this.activite.statut;
      fArray.date_cloture_activite = this.activite.date_cloture;

      if (this.activite.groupe_id == 1 || this.activite.groupe_id == 2){
        if (this.activite.missions){
          fArray.dossier_medical_id = this.activite.missions['0'].dossier_medical_id+"";
        }
      }else if (this.activite.groupe_id == 3){
        if (this.activite.missions){
          fArray.nom_partenaire = this.activite.missions['0'].nom_partenaire+"";
        }
      }else if (this.activite.groupe_id == 4){
        if (this.activite.missions){
          fArray.nom_activite = this.activite.missions['0'].nom_activite+"";
        }
      }
      return fArray;
    },

    can: function () {
      return this.hasAdminRole || this.hasGestionnaireRole || this.hasMedecinControleRole || this.hasAssistante;
    },

    groupeActivite:function (){
      if (this.activite.hasOwnProperty('groupe')){
        return this.activite.groupe.nom;
      }

      return  '';
    },

    mGroupeActivites:function(){
      let self = this;
      let activite  = _.find(this.groupeActivites,function(activite){
        return activite.slug == self.groupe;
      })

      if (!_.isUndefined(activite)){
        self.form.groupe_activite = activite.id;
      }

      return _.omit(this.groupeActivites,'missions');

    },

    mPatients: function() {
      let pArray = [];

      _.forEach(_.orderBy(this.patients,['created_at'],['desc']), function(patient) {
        let p = {};

        if((typeof patient.user == 'object') && (!_.isNull(patient.user)) ) {
          if (!_.isNull(patient.dossier)){

            let prenom = patient.user.prenom ? patient.user.prenom : '';
            prenom =  prenom.toLowerCase();
            p.text =  (patient.user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
            p.id = patient.dossier.id;
            if (patient.user.isMedicasure == '1'){
              pArray.push(p);
            }
          }
        }
      });
      return pArray;
    },

    missions:function(){
      let self = this;
      let activite =  _.find(this.groupeActivites,function(activite){
        return activite.id == self.form.groupe_id;
      })

      if (!_.isUndefined(activite)){
        let mArray = [];
        _.forEach(activite.missions, function (mission){
          mArray.push({id: mission.id,text:mission.description});
        });
        return mArray;
      }

      return [];
    },

    selectedMissions:function (){
      return this.activite.missions;
    },

    selectedMissionsField:function (){
      let self = this;
      let sArray = [];
      sArray.push({key: 'action', label: this.$i18n.t('message.action')});
      sArray.push({key: 'description', label: this.$i18n.t('message.description')});
      sArray.push({key: 'commentaire', label: this.$i18n.tc('message.commentaires',1)});
      sArray.push({key: 'statut', label: this.$i18n.t('message.cloture')});
      sArray.push({key: 'date_cloture', label: this.$i18n.t('message.dateCloture')});
      // if (self.activite.groupe_id === 1 || self.activite.groupe_id === 2){
      //   sArray.unshift({key: 'nom_patient', label: this.$i18n.t('message.nomPatient')});
      // }
      // if (self.activite.groupe_id === 3){
      //   sArray.unshift({key: 'nom_partenaire', label: this.$i18n.t('message.nomPartenaire')});
      // }
      // else if (self.activite.groupe_id === 4){
      //   sArray.unshift({key: 'nom_activite', label: this.$i18n.t('message.activite.nom')});
      // }

      return sArray;
    }
  },

  data(){
    return {
      activite_id:this.$route.params.activite,
      groupe:this.$route.params.groupe,
      showDescription:true,
      commentaireOptions:[
        {id:1,text:'Très Urgent : <12h>'},
        {id:2,text:'Urgent : <48h>'},
        {id:3,text:'Normal > 48h'}
      ],
      editable:{
        nom_activite:'',
        nom_partenaire:'',
        description:'',
        statut:false,
        commentaire:'',
        date_cloture:'',
      }
    }
  },
  methods: {
    getGroupeActivites:function (){
      let args = {
        offset: this.offset,
        limit: this.limit
      };

      this.$store.dispatch('getGroupeActivites', { args : args });
    },

    modifierMission(index){
      let element = _.pick(index.item,['commentaire','date_cloture','statut']);
      element.description = index.item.description.id+"";
      element.statut = element.statut == '0' || element.statut == false ? false :true;
      element.slug = index.item.slug;
      this.editable = element;

      this.editable.index = index.index;
      this.showDescription = false;
      },

    editMission(){
      let args = _.omit(this.editable,'index');
      this.$store.dispatch('modifierActiviteMission', { args : args, index:this.editable.index });
      this.editable = {
        nom_activite:'',
        nom_partenaire:'',
        description:'',
        statut:false,
        commentaire:'',
        date_cloture:'',
      };
      this.showDescription = true;
    },

    deleteMission(index){
      let args = {};
      args.slug = index.item.slug;
      this.$store.dispatch('deleteActiviteMission', { args : args, index: index.index });
    },

    addMission(){
      let args = {};
      args.activite_id = this.form.id;
      args.date_cloture = this.editable.date_cloture;
      args.statut = this.editable.statut;
      args.commentaire = this.editable.commentaire;
      args.description = this.editable.description;
      if (this.form.groupe_id == 1 || this.form.groupe_id == 2)
      args.dossier_medical_id = this.form.dossier_medical_id;
      if (this.form.groupe_id == 4)
      args.nom_activite = this.form.nom_activite;
      if (this.form.groupe_id == 3)
      args.nom_partenaire = this.form.nom_partenaire;

      this.$store.dispatch('ajouterActiviteMission', { args : args });
      this.editable = {
        nom_activite:'',
        nom_partenaire:'',
        description:'',
        statut:false,
        commentaire:'',
        date_cloture:'',
      };
    },
    getPatients() {
      let args = {
        offset: this.offset,
        limit: this.limit
      };

      this.$store.dispatch('getPatients', { args : args });
    },

    getDescription(item){
      return item.description;
    },

    getNomPatient(item){
      let patient =        _.find(this.mPatients, function (patient){
        return patient.id == item
      })

      if (patient){
        return  patient.text;
      }
      return '';
    },

    onSubmit(){

      if(this.selectedMissions.length > 0){


        let args = {};
        args.slug = this.form.slug;
        args.date_cloture = this.form.date_cloture_activite;
        args.statut = this.form.statut_activite;
        let successMessage = this.$i18n.t('message.activite.edit');
        let errorMessages = {
          generic: this.$i18n.t('message.genericError'),
          error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
        };

        this.$store.dispatch('UpdateActivite', { args, errorMessages, successMessage })
      }
    },

    supprimerMission(item){
      this.selectedMissions.splice(item,1);
    },



    // addToMission(){
    //   let activite = this.form.groupe_id;
    //   this.form.description = parseInt(this.form.description);
    //   let items = ['description','commentaire','date_cloture','statut']
    //   // if (activite === 1 || activite === 2)
    //   //   this.selectedMissions.unshift(_.pick(this.form,items.concat('dossier_medical_id')));
    //   if (activite === 3)
    //     this.selectedMissions.unshift(_.pick(this.form,items.concat('nom_partenaire')));
    //   else if (activite === 4)
    //     this.selectedMissions.unshift(_.pick(this.form,items.concat('nom_activite')));
    //
    //   this.form.commentaire="";
    //   this.form.nom_activite="";
    // },

    getActivite() {
      let args = {
        activite: this.activite_id
      };

      this.$store.dispatch("getActivite", {args});
    },

    errorshasField(field){
      return this.errors ? this.errors.hasOwnProperty(field) : false;
    },

    clearErrorField(field){
      this.$store.dispatch('clearErrorField', { field });

      this.getErrorsField(field);
    },

    getErrorsField(field){
      if (this.errorshasField(field)){
        return this.errors[field][0];
      }else{
        return  '';
      }
    },
  },
  validations() {
    return {
      form: {
        dossier_medical_id:{},
        groupe_id:{},
        nom_activite:{},
        nom_partenaire:{},
        description:{},
        statut:{},
        statut_activite:{},
        commentaire:{},
        date_cloture:{},
        date_cloture_activite:{},
      },
      editable: {
        nom_activite:{},
        nom_partenaire:{},
        description:{},
        statut:{},
        commentaire:{},
        date_cloture:{},
      }
    }
  },
  mounted() {
    this.getActivite();

    this.getPatients();

    this.getGroupeActivites();
  }

}
</script>

<style scoped>

</style>